//dbReducer.js
// Copyright (c) 2019 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { createAction, createActions, handleActions } from "redux-actions";

// CONSTANTS
export const GROUP_EXPAND_TOGGLE = "GROUP_EXPAND_TOGGLE";
export const PANEL_EXPAND_TOGGLE = "PANEL_EXPAND_TOGGLE";

// ACTIONS
export function groupExpandToggle(groupId) {
  return {
    type: GROUP_EXPAND_TOGGLE,
    groupId
  };
}

export function panelExpandToggle(panelId) {
  return {
    type: PANEL_EXPAND_TOGGLE,
    panelId
  };
}

// INITIAL_STATE
const initialState = {
  dbUiState: {
    layerGroupPanels: {
      rideSurveyGroup: {
        active: true
      },
      infraRequestGroup: {
        active: true
      }
    },
    layerPanels: {
      closePassPanel: {
        active: false
      },
      collisionPanel: {
        active: false
      },
      potholePanel: {
        active: false
      },
      obstructionPanel: {
        active: false
      },
      rsotherPanel: {
        active: false
      },
      widthPanel: {
        active: false
      },
      separationPanel: {
        active: false
      },
      parkingPanel: {
        active: false
      },
      timingPanel: {
        active: false
      },
      calmingPanel: {
        active: false
      },
      closuresPanel: {
        active: false
      },
      irotherPanel: {
        active: false
      }
    }
  }
};

// The reducer takes the action and uses the TYPE for routing with a switch statement
// and the payload for actioning
// Object.assign() is used so as not to mutate the original state and a new function
// call is needed for every level of the dbUiState object

function dbReducer(state = initialState, action) {
  switch (action.type) {
    case GROUP_EXPAND_TOGGLE:
      return Object.assign({}, state, {
        dbUiState: Object.assign({}, state.dbUiState, {
          layerGroupPanels: Object.assign({}, state.dbUiState.layerGroupPanels, {
            [action.groupId]: Object.assign(
              {},
              state.dbUiState.layerGroupPanels[action.groupId],
              {
                active: !state.dbUiState.layerGroupPanels[action.groupId].active
              }
            )
          })
        })
      })
    case PANEL_EXPAND_TOGGLE:
      return Object.assign({}, state, {
        dbUiState: Object.assign({}, state.dbUiState, {
          layerPanels: Object.assign({}, state.dbUiState.layerPanels, {
            [action.panelId]: Object.assign(
              {},
              state.dbUiState.layerPanels[action.panelId],
              {
                active: !state.dbUiState.layerPanels[action.panelId].active
              }
            )
          })
        })
      });
    default:
      return state;
  }
}

export default dbReducer;
